// extracted by mini-css-extract-plugin
module.exports = {"photo":"SDs1e9QUjXStJeccb_IV","-editable":"_2qb6CzDt0aJTEeykrSQF","-full-width":"aH8vRsFn_gf9Sor-tyr5","-small":"_2ZZkaNM1ExigDXwvnx1_"};